export const displayedColumnsLogistics: string[] = [
  'select',
  'info',
  'client',
  'vehicle',
  'vehicle_manufacturing_date',
  'delivery_expected_date',
  'documents',
  'updated_at',
  'stage_updated_at',
  'stage',
  'actions',
];

export const displayedColumnsSupplier: string[] = [
  'select',
  'info',
  'client',
  'vehicle',
  'documents',
  'updated_at',
  'stage_updated_at',
  'stage',
  'actions',
];

export const displayedColumnsBroker: string[] = [
  'select',
  'info',
  'client',
  'vehicle',
  'updated_at',
  'stage_updated_at',
  'stage',
  'actions',
];


export const displayedColumnsCampaign: string[] = [
  'campaign_reference',
  'name',
  'vendor',
  'fee',
  'vehicle',
  'contract',
  'period',
  'documents',
  'stage',
  'actions',
];

export const displayedColumnsCampaignBroker: string[] = [
  'campaign_reference',
  'name',
  'supplier',
  'vendor',
  'fee',
  'contract',
  'period',
  'documents',
  'stage',
  'actions',
];
export const displayedColumnsStocks: string[] = [
  'reference',
  'units',
  'vehicle',
  'vendor',
  'campaigns',
  'actions',
];


export const displayedColumnsWorkshop: string[] = [
  'ring',
  'supplier_reference',
  'client',
  'vehicle',
  'updated_at',
  'stage_updated_at',
  'stage',
  'actions',
];

export const displayedColumnsTelemarketing: string[] = [
  'select',
  'info',
  'client',
  'vehicle',
  'telemarketing',
  'updated_at',
  'stage_updated_at',
  'stage',
  'actions',
];
